/**
 * Small badge indicating the auto face-match verdict on a booking's clock-in
 * selfie. Uses a perceptual hash comparison (NOT biometrics) — colours are
 * green / amber / red and are informational only.
 */
export default function FaceMatchBadge({ verdict, distance, className = "" }) {
  if (!verdict) return null;
  const map = {
    green: {
      bg: "bg-emerald-50",
      text: "text-emerald-700",
      border: "border-emerald-200",
      label: "Face match: OK",
      dot: "bg-emerald-500",
    },
    amber: {
      bg: "bg-amber-50",
      text: "text-amber-800",
      border: "border-amber-200",
      label: "Face match: review",
      dot: "bg-amber-500",
    },
    red: {
      bg: "bg-red-50",
      text: "text-red-700",
      border: "border-red-200",
      label: "Face match: flagged",
      dot: "bg-red-500",
    },
  };
  const s = map[verdict] || map.amber;
  return (
    <span
      data-testid={`face-match-${verdict}`}
      title={distance != null ? `Perceptual hash distance: ${distance}` : "Auto face-match verdict"}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md border text-xs font-semibold ${s.bg} ${s.text} ${s.border} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {s.label}
      {distance != null && <span className="opacity-70 font-normal">· d={distance}</span>}
    </span>
  );
}
